import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';
import toast from 'react-hot-toast';
import { StarRating } from '@/components/custom/star-rating';
import { useClient } from 'jsonapi-react';
import { useParams } from 'react-router-dom';
import { NPSModal as NPS, NPSModalBody, NPSModalContent, NPSModalFooter, NPSModalHeader, NPSModalSteps, NPSModalTitle } from '@/components/custom/nps-modal';

export default function NPSModal({ answers, setAnswers }) {
  const client = useClient();
  const params = useParams();

  const [rate, setRate] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [done, setDone] = useState(false);
  const [questions, setQuestions] = useState([]);

  const fetchSurvey = async () => {
    const { data, error } = await client.fetch('live_classroom_questions');

    if (error) {
      toast.error('Erro ao carregar perguntas da pesquisa.');
      return;
    }

    const questionsNotAnswered = data.filter(question => !answers.some(answer => answer['live-classroom-question-id'] === question.id));

    setQuestions(data);
    setCurrentQuestion(questionsNotAnswered[0].id ?? 1);
  };

  const handleAnswerSurvey = async () => {
    const isAnswered = answers.find(item => item['live-classroom-question-id'] === questions?.[currentQuestion - 1]?.id);

    let response;

    if (isAnswered) {
      response = await client.mutate(`live_classroom_answers/${isAnswered.id}`, {
        rating: rate
      });
    } else {
      response = await client.mutate('live_classroom_answers', {
        rating: rate,
        'live-classroom-id': Number(params.liveClassId),
        'live-classroom-question-id': questions?.[currentQuestion - 1]?.id
      });
      setAnswers(prev => [...prev, response.data]);
    }

    if (response.error) {
      toast.error('Erro ao responder pergunta.');
      return;
    }

    if (currentQuestion < 5) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      toast.success('Agradecemos por responder a pesquisa.');
      setDone(true);
    }
  };

  useEffect(() => {
    fetchSurvey();
  }, []);

  return ReactDOM.createPortal(
    <NPS
      style={{ pointerEvents: done ? 'none' : 'auto' }}
      onClick={() => {
        toast.error('Termine de responder o questionário');
      }}
    >
      <NPSModalContent
        state={!done ? 'open' : 'closed'}
        onClick={e => e.stopPropagation()}
      >
        <NPSModalHeader>
          <NPSModalTitle>
            {questions?.[currentQuestion - 1]?.id}. {questions[currentQuestion - 1]?.title}
          </NPSModalTitle>
        </NPSModalHeader>

        <NPSModalBody>
          <StarRating
            rate={rate}
            setRate={setRate}
            setDone={setDone}
            onClick={handleAnswerSurvey}
          />
        </NPSModalBody>

        <NPSModalFooter>
          {currentQuestion > 1 && (
            <button
              type="button"
              className="bg-none p-0.5"
              onClick={() => setCurrentQuestion(currentQuestion - 1)}
            >
              <FiArrowLeft
                size={16}
                className="relative text-primary block"
              />
            </button>
          )}

          <NPSModalSteps>{questions?.[currentQuestion - 1]?.id}/5</NPSModalSteps>

          {currentQuestion < 5 && (
            <button
              type="button"
              className="bg-none p-0.5"
              onClick={() => setCurrentQuestion(currentQuestion + 1)}
            >
              <FiArrowRight
                size={16}
                className="relative text-primary block"
              />
            </button>
          )}
        </NPSModalFooter>
      </NPSModalContent>
    </NPS>,
    document.getElementById('modal_root')
  );
}
